import { getRequest, postRequest, putRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken } from "../../utils/tokenUtils";

// -----------------------------------
// Consent MASTER API's
// -----------------------------------
export const AddConsent = async ({ message }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}consent/create`,
      data: { message },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error('addConsent Error:', error);
    throw error;
  }
};

//  FIXED: Pass id param for single view (list when no id)
export const ViewConsent = async ({ id } = {}) => {
  try {
    const token = getAuthToken();
    const url = id 
      ? `${API_URLS.ADMIN}consent/view/${id}`  // Single view endpoint (implement if needed)
      : `${API_URLS.ADMIN}consent/view`;       // List/single current
    const response = await getRequest({
      url,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error('viewConsent Error:', error);
    throw error;
  }
};

//  Add this to service - replaces ViewConsent({id})
export const EditConsent = async ({ id }) => {
  try {
    const token = getAuthToken();
    const response = await getRequest({ 
      url: `${API_URLS.ADMIN}consent/edit/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  } catch (error) {
    console.error('editConsent Error:', error);
    throw error;
  }
};


//  FIXED: Expects {id, message} directly, matches backend
export const updateConsent = async ({ id, message }) => {
  try {
    const token = getAuthToken();
    const response = await putRequest({
      url: `${API_URLS.ADMIN}consent/update/${id}`,
      data: { id, message },  // Direct fields, no extra nesting
      headers: { Authorization: `Bearer ${token}` }
    });
    return response;
  } catch (error) {
    console.error('updateConsent Error:', error);
    throw error;
  }
};
